<template>
	<Head title="Aula"></Head>

    <div class="modal fade" id="pauseModal" tabindex="-1" aria-labelledby="pauseModal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Aula pausada</h1>
                </div>
                <div class="modal-body text-center">
                    <vue-countdown
                        @end="loading = true"
                        v-if="class_pause"
                        :time="timer_deadline"
                        v-slot="{ minutes, seconds }">
                        Tempo restante: {{ minutes }} minutos, {{ seconds }} segundos.
                    </vue-countdown>

                    <p class="m-0 mt-3">
                        Após finalizar o tempo de pausa, a aula irá ser continuada automáticamente.
                    </p>
                </div>
                <div class="modal-footer">
                    <button
                        @click="finishClassPause(class_pause!)"
                        :disabled="loading || !class_pause"
                        type="button"
                        class="btn btn-primary"
                        data-bs-dismiss="modal">
                        Continuar aula
                    </button>
                </div>
            </div>
        </div>
    </div>

	<meeting_iframe
        @successfully_loaded="api => jitsi_api = api"
        @attachments_button_clicked="() => show_attachments = true"
        :key="meeting_iframe_key"
        ref="meeting_iframe_component"
        :token_jwt="props.token_jwt"
        :room_name="props.room_name"
        :jitsi_domain="props.jitsi_domain"
        :toolbar_buttons="[
            'camera',
            'microphone',
            'chat',
            'fullscreen',
            'hangup',
            'desktop',
            'tileview',
            'participants-pane',
            'raisehand',
            'whiteboard',
            'etherpad'
        ]"
    />

    <attachments_modal
        :url="props.attachment_url" 
        @close="show_attachments = false"
        :show="show_attachments"/>  
</template>

<script setup lang="ts">
    import { computed, onBeforeMount, onMounted, PropType, Ref, ref, watch } from 'vue';
    import { Head, router } from '@inertiajs/vue3';
    import meeting_iframe from '../../components/Class/meeting_iframe.vue';
    import { menuStore } from '../../stores/menu';
    import VueCountdown from '@chenfengyuan/vue-countdown';
    import { ClassPause } from '../../Interfaces/ClassPause';
    import axios from 'axios';
    import attachments_modal from '../../components/Class/attachments_modal.vue';

    const props = defineProps({
        token_jwt: { type: String, required: true },
        room_name: { type: String, required: true },
        jitsi_domain: { type: String, required: false },
        can_load_jitsi: { type: Boolean, required: true },
        ws_url: { type: String, required: true },
        class_pause: { type: Object as PropType<ClassPause>, required: false },
        pause_minutes_limit: {type: Number, required: true },
        attachment_url: {type: String, required: true },
    });

    const show_attachments = ref(false)

    const class_pause: Ref<ClassPause | null> = ref(null)

    const ws = new WebSocket(props.ws_url)

    ws.addEventListener('message', event => {
        const data = JSON.parse(event.data)

        if (data.event === "STARTED_CLASS_PAUSE") {
            loading.value = false
            class_pause.value = data.class_pause
            pause_modal.show()
        }

        if (data.event === "FINISHED_CLASS_PAUSE") {
            class_pause.value = null
            pause_modal.hide()
            toastr.success('Pausa finalizada com sucesso!')
        }
    })

    const jitsi_api = ref(null)

	const recording = ref(false);

    const meeting_iframe_key = ref(0);

    const meeting_iframe_component = ref<InstanceType<typeof meeting_iframe>>();

    let pause_modal:any = null

    const loading = ref(false)

    const timer_deadline = computed(() => {
        const started_at = new Date(class_pause.value?.started_at as string)
        
        const duration_minutes = class_pause.value?.duration_in_minutes ?? props.pause_minutes_limit

        started_at.setMinutes(started_at.getMinutes() + duration_minutes)

        return started_at.getTime() - Date.now()
    })

    async function finishClassPause(pause: ClassPause) {
        try {
            loading.value = true

            await axios.post(pause.finish_pause_url as string)

            class_pause.value = null

            pause_modal.hide()
        } catch (e) {
            alert('Erro ao finalizar intervalo: ' + e)
        } finally {
            loading.value = false
        }
    }

	function startClassRecordingStateVerificationTimer() {
		const threshold = 300; //5 minutos em segundos

		let counter = 0;

		const timer = setInterval(() => {
			if (recording.value) {
				clearInterval(timer);
				return;
			}

			counter++;

			if (counter == threshold) {
                //@ts-ignore
				jitsi_api.value?.executeCommand('startRecording', {
					mode: 'file',
				});

				counter = 0;
			}
		}, 1000);
	}

	// watch(recording, async (newValue, oldValue) => {
	// 	if (!newValue) {
	// 		startClassRecordingStateVerificationTimer();
	// 	}
	// });

    // watch(jitsi_api, async (newValue, oldValue) => {
    //     if(newValue) {
    //         startClassRecordingStateVerificationTimer();

    //         jitsi_api.value?.addListener(
    //             'recordingStatusChanged',
    //             (event) => (recording.value = event.on)
    //         );
    //     }
    // });

	onMounted(() => {
        pause_modal = new bootstrap.Modal('#pauseModal');

        if(!props.jitsi_domain && props.can_load_jitsi) {
            const refresh_jitsi_domain = setInterval(()=> {
                if(props.jitsi_domain) {
                    clearInterval(refresh_jitsi_domain);
                    return ;
                }

                router.reload({
                    only: ['jitsi_domain'],
                    onFinish: () => meeting_iframe_key.value += 1
                })
            }, 20000);
        }

        if(!jitsi_api.value) {
            const reload_iframe_component_timer = setInterval(() => {

                if(jitsi_api.value) {
                    clearInterval(reload_iframe_component_timer);
                    return;
                }

                meeting_iframe_key.value += 1
            }, 5000)
        }

        if (props.class_pause) {
            class_pause.value = props.class_pause
            pause_modal.show()
        }
	});

    onBeforeMount(() => {
        menuStore().isMeetingPage();
    });
</script>
